export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
